module.exports = __webpack_public_path__ + "img/control-radio-check.d1f82c2f.svg";